export { WithBordersAndSeparatorsVariation as default } from './WithBordersAndSeparatorsVariation';
